import React from 'react';
import { VisualStat } from './VisualStat';
import type { WorkStat } from '../../../types/work';
type ClearDocsVisualProps = {
  stat?: WorkStat;
};
const ROWS = [{
  label: 'Review',
  className: 'bg-[#FCEFA8] text-[#6B5200]',
  w: 'w-[62%]'
}, {
  label: 'Review',
  className: 'bg-[#FCEFA8] text-[#6B5200]',
  w: 'w-[62%]'
}, {
  label: 'Approved',
  className: 'bg-[#DCEFD3] text-[#2F6B2A]',
  w: 'w-[52%]'
}];

/** Home card visual: the audit number, plus the document list and an Accept / Reject viewer, cropped at the bottom. */
export function ClearDocsVisual({
  stat
}: ClearDocsVisualProps) {
  return <div aria-hidden className="absolute inset-0 bg-ink-soft" data-id="element-399" data-mp="22al8o1rq1jx6">
      {stat && <VisualStat stat={stat} tone="ink" data-id="element-400" data-mp="1xcjo1cendcjl" />}

      <div className="absolute -bottom-6 left-[34%] top-[20%] w-[19%] rounded-t-[22px] bg-white p-[1.4%] pt-[3%]" data-id="element-401" data-mp="1xdkxjcg0lqz7">
        <div className="h-[3px] w-[55%] rounded-full bg-[#1E4B48]" data-id="element-402" data-mp="1t9vd8z6dhvjz" />
        <div className="mt-[8%] flex gap-1.5 text-[9px] font-medium" data-id="element-403" data-mp="1ocmt4t1nzhg3">
          <span className="rounded-full bg-[#1E4B48] px-2 py-0.5 text-white" data-id="element-404" data-mp="1nva0zatcxv7s">All</span>
          <span className="hidden rounded-full border border-[#E3E6E3] px-2 py-0.5 text-[#4F5955] lg:inline" data-id="element-405" data-mp="1slqesw13biuo">Needs review</span>
        </div>
        <ul className="mt-[8%]" data-id="element-406" data-mp="1evd78us4265v">
          {ROWS.map((r, i) => <li key={i} className="flex items-center justify-between gap-2 border-b border-[#EEF0EE] py-[7%]" data-id="element-407" data-mp="1ivno52hfygzi" data-mpi={i}>
              <span className={`h-1.5 rounded-full bg-[#E3E6E3] ${r.w}`} data-id="element-408" data-mp="26kzyw6sf2x3x" />
              <span className={`rounded-full px-1.5 py-0.5 text-[8px] font-semibold ${r.className}`} data-id="element-409" data-mp="2bkm88554jt7g">{r.label}</span>
            </li>)}
        </ul>
      </div>

      <div className="absolute -bottom-6 left-[57%] top-[30%] w-[19%] rounded-t-[22px] bg-white p-[1.4%] pt-[1.6%]" data-id="element-410" data-mp="1xkjvexbobpz2">
        <div className="aspect-[1/0.92] rounded-xl bg-[#F2F4F3]" data-id="element-411" data-mp="22lr2eu5zsl4o" />
        <div className="mt-[6%] grid grid-cols-2 gap-[5%]" data-id="element-412" data-mp="m43awpl9ij5c">
          <div className="h-6 rounded-md border-[1.5px] border-[#B03F2B] sm:h-8" data-id="element-413" data-mp="r5ajurz55odl" />
          <div className="h-6 rounded-md bg-[#1E4B48] sm:h-8" data-id="element-414" data-mp="2stx5oq5zhabf" />
        </div>
      </div>
    </div>;
}